import styled from 'styled-components';

import { imageUrl } from '~/utils/url-helpers';

import { color, spacing, typography, media } from '~/theme';

export const FooterContainer = styled.footer`
    background-color: ${color.footerBG};
    border-bottom: 4px solid ${color.palette.greyscale70};
    color: ${color.palette.white};
    padding: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing9} ${spacing.spacing0};

    p {
        &:last-child {
            margin-bottom: ${spacing.spacing5};

            @media ${media.small} {
                margin-bottom: ${spacing.spacing0};
            }
        }

        a {
            color: ${color.palette.white};
            font-weight: ${typography.fontWeightSemiBold};

            &:hover,
            &:focus {
                text-decoration: none;
            }
        }
    }
`;

export const ExpandedFooterTopBlock = styled.div`
    background-color: ${color.footerSectionTopBG};
    padding: ${spacing.spacing9} ${spacing.spacing0};
    position: relative;

    &:before {
        content: '';
        background-color: ${color.footerSectionTopBeforeBG};
        background-image: url(${imageUrl('images/footer-expanded-supergraphic-logo.svg')});
        background-position: calc(50vw - 125rem) -64rem;
        background-size: 165rem;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        @media ${media.small} {
            background-size: 250rem;
            background-position: calc(50vw - 195rem) -106rem;
        }

        @media ${media.medium} {
            background-size: 305rem;
            background-position: calc(50vw - 222rem) -160rem;
        }
    }
`;

export const ExpandedFooterBottomBlock = styled.div`
    background-color: ${color.footerBG};
    padding-top: ${spacing.spacing9};
`;

export const FooterLinksContainer = styled.ul`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    list-style: none;
    margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing0};
    padding: ${spacing.spacing0};

    li {
        padding: ${spacing.spacing1} ${spacing.spacing0};
    }

    @media ${media.small} {
        flex-direction: row;
    }

    @media ${media.medium} {
        margin-bottom: ${spacing.spacing2};
    }
`;

export const FooterLink = styled.a`
    color: ${color.palette.white};
    display: inline-block;
    padding: ${spacing.spacing2} ${spacing.spacing0};
    margin: ${spacing.spacing0};
    text-decoration: underline;

    &:hover,
    &:focus {
        text-decoration: none;
    }

    &:visited,
    &:active,
    &:hover {
        color: ${color.palette.white};
    }

    @media ${media.small} {
        padding: ${spacing.spacing0};
        margin: ${spacing.spacing0} ${spacing.spacing8} ${spacing.spacing4} ${spacing.spacing0};
    }
`;

export const FooterCopyrightLink = styled(FooterLink)`
    margin: ${spacing.spacing0};
`;

export const FooterSocialMediaLinksContainer = styled(FooterLinksContainer)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const FooterSocialMediaLink = styled.a`
    background: transparent;
    border-radius: 45%;
    margin: ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing0} ${spacing.spacing0};
    padding: ${spacing.spacing0};
    outline: none;

    height: calc(${spacing.spacing8} + ${spacing.spacing2});
    width: calc(${spacing.spacing8} + ${spacing.spacing2});

    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        width: 36px;
        height: 36px;

        @media ${media.small} {
            width: 32px;
            height: 32px;
        }
    }

    &:hover,
    &:focus {
        background-color: ${color.footerSocialMediaLinkHover};
    }

    @media ${media.small} {
        margin-bottom: ${spacing.spacing3};
        height: ${spacing.spacing8};
        width: ${spacing.spacing8};
    }
`;

export const FooterRow = styled.div`
    position: relative;
    margin: 0 auto;
    max-width: 22.625rem;
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (${media.small}) {
        max-width: 48rem;
    }

    @media ${media.medium} {
        flex-direction: row;
        max-width: 72rem;
    }
`;

export default {
    FooterContainer,
    FooterRow,
    ExpandedFooterTopBlock,
    ExpandedFooterBottomBlock,
    FooterLinksContainer,
    FooterLink,
    FooterCopyrightLink,
    FooterSocialMediaLinksContainer,
    FooterSocialMediaLink,
};
